export default class Rectangle {
    
    x: number;
    y: number;
    width: number;
    height: number;

    constructor(x: number, y: number, width: number, height: number) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }

    add(tmp: Rectangle): any {
        // Expand?
    }
    
    getY(): number {
        return this.y;
    }
    getX(): number {
        return this.x;
    }
    getHeight(): number {
        return this.height;
    }
    getWidth(): number {
        return this.width;
    }

}